import React from "react";
import ApproveForView from "./ApproveForView";

export const ApproveForContainer = () => {
  return <ApproveForView />;
};

export default ApproveForContainer;
